export const isDatabasesSupported = () =>
  window.indexedDB !== undefined && window.indexedDB.databases !== undefined
